import React, { Component } from "react";
import "./App.css";
import VornoiSuburb from "./VoronoiSuburb";
import areaNames from "./areas.json";
import suburbNames from "./top-suburbs.json";
import percentChange from "./value-change.json";
import areaSuburbs from './suburbs.json';

const areaLookup = JSON.parse('{"Ashburton" : "Ashburton", "Auckland" : "Auckland", "Central Otago & Waitaki" : "Central+Otago+%26+Waitaki", "Christchurch" : "Christchurch", "Clutha" : "Clutha", "Coromandel" : "Coromandel", "Dunedin" : "Dunedin", "Gisborne" : "Gisborne", "Gore" : "Gore", "Hamilton City" : "Hamilton+City", "Hastings" : "Hastings", "Hauraki" : "Hauraki", "Hawke\'s Bay" : "Hawke%27s+Bay", "Horowhenua" : "Horowhenua", "Hurunui" : "Hurunui", "Invercargill" : "Invercargill", "Kapiti Coast" : "Kapiti+Coast", "Kawerau" : "Kawerau", "Lower Hutt" : "Lower+Hutt", "Manawatu" : "Manawatu", "Manukau" : "Manukau", "Marlborough/Kaikoura" : "Marlborough%2FKaikoura", "Napier" : "Napier", "Nelson" : "Nelson", "New Plymouth" : "New+Plymouth", "North Shore" : "North+Shore", "Northland" : "Northland", "Opotiki" : "Opotiki", "Papakura/Franklin" : "Papakura%2FFranklin", "Porirua" : "Porirua", "Queenstown Lakes" : "Queenstown+Lakes", "Rangitikei" : "Rangitikei", "Rodney" : "Rodney", "Rotorua" : "Rotorua", "Ruapehu" : "Ruapehu", "Selwyn & Waimakariri" : "Selwyn+%26+Waimakariri", "Southland" : "Southland", "Taranaki" : "Taranaki", "Tararua" : "Tararua", "Tasman" : "Tasman", "Taupo" : "Taupo", "Tauranga" : "Tauranga", "Timaru" : "Timaru", "Upper Hutt" : "Upper+Hutt", "Waikato" : "Waikato", "Waimate" : "Waimate", "Waipa" : "Waipa", "Wairarapa" : "Wairarapa", "Waitakere" : "Waitakere", "Wellington" : "Wellington", "Western Bay of Plenty" : "Western+Bay+of+Plenty", "Westland/Grey/Buller" : "Westland%2FGrey%2FBuller", "Whakatane" : "Whakatane", "Whanganui" : "Whanganui", "Whangarei" : "Whangarei"}')

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      viewPortWidth: window.document.documentElement.clientWidth,
      loaded: false,
      area: "Auckland",
      areaData: [],
      suburb: "Herne Bay",
      three_months: "",
      two_years: "",
      peak_change: ""
    };
    this.buildOptionsList = this.buildOptionsList.bind(this);
    this.handleAreaSelect = this.handleAreaSelect.bind(this);
    this.readData = this.readData.bind(this);
    this.buildSuburbsList = this.buildSuburbsList.bind(this);
    this.handleSuburbSelect = this.handleSuburbSelect.bind(this);
    this.handleSuburbClick = this.handleSuburbClick.bind(this);
  }

  readData() {

    import("./Auckland.json")
      .then(d => this.setState({areaData: d}))
      .catch(err => console.log(err))
    const filter_suburbs = suburbNames.filter(d => d.area === this.state.area);
    const highlighted_suburb = filter_suburbs[0].suburb;
    const filter_percent_change = percentChange.filter(
      d => d.suburb === this.state.suburb
    );
    const three_months = filter_percent_change[0].three_months;
    const two_years = filter_percent_change[0].two_years;
    const peak_change = filter_percent_change[0].peak_change;

    this.setState({
      suburb: highlighted_suburb,
      three_months: three_months,
      two_years: two_years,
      peak_change: peak_change
    });
  }

  buildOptionsList(items) {
    let result = [];
    result.push(
      <option key="select-default" default>Select your area...</option>
    );
    items.forEach(item => {
      result.push(<option value={item} key={item}>{item}</option>);
    });
    return result;
  }

  buildSuburbsList(items) {
    let result = [];
    result.push(
      <option key="select-default" default>Select your suburb to compare...</option>
    );
    items.forEach(item => {
      result.push(<option value={item} key={item}>{item}</option>);
    });
    return result;
  }

  handleSuburbClick(name) {
    const selectedArea = this.state.area;
    const filter_percent_change = percentChange.filter(
      d => d.suburb === name
    );
    const three_months = filter_percent_change[0].three_months;
    const two_years = filter_percent_change[0].two_years;
    const peak_change = filter_percent_change[0].peak_change;
    this.setState({
      area: selectedArea,
      suburb: name,
      three_months: three_months,
      two_years: two_years,
      peak_change: peak_change
    });


  }

  handleSuburbSelect(event) {
    const selectedAreaSuburbs = areaSuburbs.filter( (d) => d.area === this.state.area);
    const selectedArea = this.state.area;
    const suburbs = [...new Set(selectedAreaSuburbs.map(d => d.suburb))] 
    let selectedSuburb = suburbs[event.currentTarget.selectedIndex -1];
    const filter_percent_change = percentChange.filter(
      d => d.suburb === selectedSuburb
    );
    const three_months = filter_percent_change[0].three_months;
    const two_years = filter_percent_change[0].two_years;
    const peak_change = filter_percent_change[0].peak_change;
    this.setState({
      area: selectedArea,
      suburb: selectedSuburb,
      three_months: three_months,
      two_years: two_years,
      peak_change: peak_change
    });

    
  } 

  handleAreaSelect(event) {
    let selectedArea = areaNames[event.currentTarget.selectedIndex - 1];
    const filter_suburbs = suburbNames.filter(d => d.area === selectedArea);
    const highlighted_suburb = filter_suburbs[0].suburb;
    const filter_percent_change = percentChange.filter(
      d => d.suburb === highlighted_suburb
    );
    const three_months = filter_percent_change[0].three_months;
    const two_years = filter_percent_change[0].two_years;
    const peak_change = filter_percent_change[0].peak_change;
    this.setState({
      area: selectedArea,
      suburb: highlighted_suburb,
      three_months: three_months,
      two_years: two_years,
      peak_change: peak_change,
      areaData: []
    });
    import("./" + areaLookup[selectedArea] + '.json')
      .then(d => this.setState({areaData: d}))
  }

  componentDidMount() {
    this.readData();
  }

  componentDidUpdate(prevProps, prevState) {
  }

  render() {
    const selectedAreaSuburbs = areaSuburbs.filter( (d) => d.area === this.state.area);
    const suburbs = [...new Set(selectedAreaSuburbs.map(d => d.suburb))] 

    return (
      <div className="App">
        <select
          className="main-select"
          onChange={this.handleAreaSelect}
          value={this.state.area}
        >
          {this.buildOptionsList(areaNames)}
        </select>

        <VornoiSuburb
         suburb={this.state.suburb}
         clickSuburb={this.handleSuburbClick}
         area={this.state.area}
         area_series={this.state.areaData}
          height={440}
          width={this.state.viewPortWidth}
        />
        <small className="note">Please note the y-axis starts from minimum value, not zero</small>

        <h3><span className="selected-suburb">{this.state.suburb}</span></h3>

        <select
          className="main-select"
          onChange={this.handleSuburbSelect}
          value={this.state.suburb}
        >
          {this.buildSuburbsList(suburbs)}
        </select>

         <div id="container">
           <h4>E-valuer median value estimate percent change</h4>
            <div id="left">
              <p>Since Oct 2007</p>
              {this.state.peak_change}%
             
              </div>
            <div id="right">
               <p>Three months to May 2018</p>
              {this.state.three_months}%
            </div>
            
            <div id="center">
              <p>Two years to May 2018</p>
              {this.state.two_years}%
              </div>
          </div>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js